import React, { FC } from 'react';
import { View } from 'react-native';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import NCFileBatchEvents from '@v2/pages/common/components/NCFileBatchEvents';
import { NcFileBatchEventType } from '@v2/pages/common/enums';
import { connect } from 'react-redux';
import { scale } from '@components/frame';
import { SCREEN_PADDING_HORIZONTAL } from '@v2/pages/common/constants/base.constants';
import { Machine } from '@interfaces/machines';

interface NCFileEventsTraceProps extends NavigationProps {
  selectedItem: Machine;
}

const NCFileEventsTraceComponent: FC<NCFileEventsTraceProps> = ({ lg, selectedItem }) => {
  return (
    <MachinesProvider
      lg={lg}
      panelViewMode={false} //TODO: remove this later
      onBack={() => {}}
      getList={(props) => <TimelineItemsList {...props} />}
      withDefaultComponent
    >
      <View style={{ paddingHorizontal: scale(SCREEN_PADDING_HORIZONTAL), flex: 1 }}>
        <NCFileBatchEvents {...{ eventType: NcFileBatchEventType.TRACE, ncFileId: selectedItem?.machineStatus?.ncFileId }} />
      </View>
    </MachinesProvider>
  );
};

const NCFileEventsTrace = connect(({ machines: { selectedItem } }) => ({ selectedItem }), {})(NCFileEventsTraceComponent);

export { NCFileEventsTrace };
